import { ExternalLink, TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useDependencies } from '@/services/Dependencies';
import { findCreditExhaustion } from '@/utils/creditExhaustion';

import { ANTHROPIC_BILLING_URL, styles } from './CreditAlertBanner.constants';

// Platform-wide alert for Anthropic credit exhaustion. While the account has
// no credits every conversation crashes and auto-hands-off to the support
// team, so this deserves more than a red card buried in the Dependencies
// page. Renders nothing when the LLM dependency is healthy; the query is
// deduped with the Dependencies page via the shared query key.
export const CreditAlertBanner = () => {
	const { t } = useTranslation('translation', { keyPrefix: 'creditAlert' });
	const { data } = useDependencies();
	const creditIssue = data ? findCreditExhaustion(data.dependencies) : null;

	if (!creditIssue) return null;

	return (
		<aside className={styles.banner} role="alert">
			<TriangleAlert className="h-md w-md shrink-0 text-red-700" />
			<div className="min-w-0 flex-1">
				<p className={styles.title}>{t('TITLE')}</p>
				<p className={styles.description}>{t('DESCRIPTION')}</p>
			</div>
			<a href={ANTHROPIC_BILLING_URL} target="_blank" rel="noreferrer" className={styles.cta}>
				{t('CTA')}
				<ExternalLink className="h-sm w-sm" />
			</a>
		</aside>
	);
};
